export const ADD = 'ADD';
export const EDIT = 'EDIT';
export const DELETE = 'DELETE';
export const LOADING = 'LOADING';

export const SET = 'SET';
export const HIDE = 'HIDE';

export const CHANGE = 'CHANGE';
